module.exports = __webpack_public_path__ + "static/img/mvci.3970ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/mvci.png
// module id = 6+pV
// module chunks = 10